import _ from 'lodash'
import { ApplicationContext } from '../applicationContext'
import * as uuid from 'uuid'

export function range(...params: any[]): number[] {
  return _.range.apply(null, params)
}

/**
 * Generate a deeplink to Entity details.
 */
export function deeplinkEntityDetails(id: string): string {
  const context = this as ApplicationContext
  const host = context?.getDeeplinkHost() ?? ''
  return `${host}/entity/${id}`
}

export function getEnvironment(): string {
  const context = this as ApplicationContext;
  const host = context?.getDeeplinkHost() ?? '';
  const environmentMap: Record<string, string> = {
    'localhost': 'local',
    'app.withvector.com': 'production',
    'm.withvector.com': 'production',
    'withvector': 'production',
    'app.withvector1.com': 'withvector1',
    'm.withvector1.com': 'withvector1',
    'withvector1': 'withvector1',
    'app.withvector2.com': 'withvector2',
    'm.withvector2.com': 'withvector2',
    'withvector2': 'withvector2',
    'app.withvector3.com': 'withvector3',
    'm.withvector3.com': 'withvector3',
    'withvector3': 'withvector3',
    'app.withvector4.com': 'withvector4',
    'm.withvector4.com': 'withvector4',
    'withvector4': 'withvector4',
    'app.withvector5.com': 'withvector5',
    'm.withvector5.com': 'withvector5',
    'withvector5': 'withvector5',
    'app.withvector6.com': 'withvector6',
    'm.withvector6.com': 'withvector6',
    'withvector6': 'withvector6',
    'app.withvector7.com': 'withvector7',
    'm.withvector7.com': 'withvector7',
    'withvector7': 'withvector7',
    'app.withvector8.com': 'withvector8',
    'm.withvector8.com': 'withvector8',
    'withvector8': 'withvector8',
    'app.withvector-staging.com': 'withvector-staging',
    'm.withvector-staging.com': 'withvector-staging',
    'withvector-staging': 'withvector-staging',
    'app.withvector-demo.com': 'withvector-demo',
    'm.withvector-demo.com': 'withvector-demo',
    'withvector-demo': 'withvector-demo',
  };
  return environmentMap[host] ?? 'unknown';
}

export function BTOA(value: string): string {
  return btoa(value)
}

export function ATOB(value: string): string {
  return atob(value)
}

/**
 * Generate a deeplink to a Workflow Execution.
 */
export function deeplinkWorkflow(executionId: string, storyId: string): string {
  const context = this as ApplicationContext
  const host = context?.getDeeplinkHost() ?? ''
  const deeplink = `${host}/workflow/${executionId}`
  const storyParam = _.isEmpty(storyId) ? '' : `?storyId=${storyId}`
  return deeplink + storyParam
}

// TODO(Peter): this should probably be a custom function
export function joinWeight(...params: any[]): string {
  const weights = _.chain(params[0])
    .compact()
    .filter((weight: any) => {
      return weight.value && weight.unit
    })
    .value()

  const units = _.map(weights, 'unit')
  const values = _.chain(weights)
    .map('value')
    .map((x) => parseInt(x))
    .value()

  // if all unit are the same, return total
  if (_.sortedUniq(units).length == 1) {
    return _.sum(values) + ' ' + (units[0] === 'Kilograms' ? 'kg' : 'lbs')
  }

  // if units are different, return join items
  const normalizeWeights = []
  _.forEach(weights, (weight) => {
    const entry = weight.value + (weight.unit === 'Kilograms' ? ' kg' : ' lbs')
    normalizeWeights.push(entry)
  })
  return normalizeWeights.join(', ')
}

export function joinValue(...params: any[]) {
  const currency = params[0]
  const currencyType = _.map(currency, 'unit')
  const currencyValue = _.map(currency, 'value').map((x: any) => {
    // Need this because when we add cargo initial value is undefined
    if (isNaN(x)) return
    return parseFloat(x)
  })
  const filteredValues = _.filter(currencyValue, (value) => value !== undefined)
  // We assume all of the values are in one currency, also removing the
  // undefined which appear when we add a cargo intially and dont save it.
  if (_.filter(_.uniq(currencyType), (type) => type !== undefined).length == 1) {
    return '$' + _.sum(filteredValues).toFixed(2) + ' ' + currencyType[0]
  }
  //TODO:(DAVID) If they are mixed currency... we should figure out what to do...
  // This should not happen since we only have USD available for now.
  return 0
}

export function getPlatform(): string {
  const context = this as ApplicationContext
  return context?.getPlatform() ?? 'unknown'
}

export function getWindowDimensions(): object {
  const context = this as ApplicationContext
  return context?.getWindowDimensions() ?? {}
}

/**
 * Utility Function: detects if the passed in value represents a Promise-like object.
 */
export function isPromise(value: any): boolean {
  return (
    !_.isNil(value) &&
    _.isObject(value) &&
    typeof _.get(value, 'then') === 'function' &&
    typeof _.get(value, 'catch') === 'function'
  )
}

export function getUUID(): string {
  return uuid.v4()
}
